import { createFileRoute } from "@tanstack/react-router";
import { getAuthGetCurrentUserQueryOptions } from "@/orval/auth";
import { ChangePasswordPage } from "./-components/change-password-page";

export const Route = createFileRoute("/_app/my/change-password")({
  loader: ({ context }) => context.queryClient.ensureQueryData(getAuthGetCurrentUserQueryOptions()),
  component: ChangePasswordPage,
});
